export default [{
    "date": 1445438181081,
    "row": 15,
    "col": 11,
    "squares": [
        [3, 6, "#FFFF00"],
        [4, 6, "#FFFF00"],
        [5, 6, "#FFFF00"],
        [4, 5, "#FFFF00"],
        [4, 7, "#FFFF00"],
        [6, 6, "#008000"],
        [7, 5, "#FF0000"],
        [7, 6, "#008000"],
        [7, 7, "#008000"],
        [8, 4, "#008000"],
        [8, 5, "#008000"],
        [8, 6, "#FF0000"],
        [8, 7, "#008000"],
        [8, 8, "#008000"],
        [9, 5, "#0000FF"],
        [9, 6, "#008000"],
        [9, 7, "#FF0000"],
        [10, 4, "#008000"],
        [10, 5, "#008000"],
        [10, 6, "#0000FF"],
        [10, 7, "#008000"],
        [10, 8, "#008000"],
        [11, 3, "#008000"],
        [11, 4, "#008000"],
        [11, 5, "#008000"],
        [11, 6, "#008000"],
        [11, 7, "#0000FF"],
        [11, 8, "#008000"],
        [11, 9, "#008000"],
        [12, 6, "#800000"],
        [13, 6, "#800000"],
        [1, 1, "#808080"],
        [1, 2, "#000000"],
        [1, 3, "#808080"],
        [1, 4, "#000000"],
        [1, 5, "#808080"],
        [1, 6, "#000000"],
        [1, 7, "#808080"],
        [1, 8, "#000000"],
        [1, 9, "#808080"],
        [1, 10, "#000000"],
        [1, 11, "#808080"],
        [2, 11, "#000000"],
        [3, 11, "#808080"],
        [4, 11, "#000000"],
        [5, 11, "#808080"],
        [6, 11, "#000000"],
        [7, 11, "#808080"],
        [8, 11, "#000000"],
        [9, 11, "#808080"],
        [10, 11, "#000000"],
        [11, 11, "#808080"],
        [12, 11, "#000000"],
        [13, 11, "#808080"],
        [14, 11, "#000000"],
        [15, 11, "#808080"],
        [15, 10, "#000000"],
        [15, 9, "#808080"],
        [15, 8, "#000000"],
        [15, 7, "#808080"],
        [15, 6, "#000000"],
        [15, 5, "#808080"],
        [15, 4, "#000000"],
        [15, 3, "#808080"],
        [15, 2, "#000000"],
        [15, 1, "#808080"],
        [14, 1, "#000000"],
        [13, 1, "#808080"],
        [12, 1, "#000000"],
        [11, 1, "#808080"],
        [10, 1, "#000000"],
        [9, 1, "#808080"],
        [8, 1, "#000000"],
        [6, 1, "#000000"],
        [7, 1, "#808080"],
        [5, 1, "#808080"],
        [4, 1, "#000000"],
        [3, 1, "#808080"],
        [2, 1, "#000000"]
    ]
}, ]
